import { render } from "./NoticeAddItems.vue?vue&type=template&id=5884312f&scoped=true"
import script from "./NoticeAddItems.vue?vue&type=script&lang=js"
export * from "./NoticeAddItems.vue?vue&type=script&lang=js"

import "./NoticeAddItems.vue?vue&type=style&index=0&id=5884312f&scoped=true&lang=css"
import "./NoticeAddItems.vue?vue&type=style&index=1&id=5884312f&lang=css"

import exportComponent from "C:\\frotend\\d7m_front_sindico\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5884312f"]])

export default __exports__